'use strict';

//Utility
import React from 'react';
//import autoBind from 'react-autobind';
import Formatter from '../../utils/Formatter';

//Components
import SectionHeader from '../Common/SectionHeader.jsx';
import RadioButton from '../Common/RadioButton.jsx';
//Constants
import ApplicationConstants from '../../constants/ApplicationConstants';
var YesNoValues = ApplicationConstants.YesNoValues;
//Store
import AdviserAuthorityStore from '../../stores/AdviserAuthorityStore.js';
//Action
import AdviserAuthorityActions from '../../actions/AdviserTransactAuthorityActions.js';
var ApplicationActions = require('../../actions/ApplicationActions');


function getStateFromStores() {
    return {
        model: AdviserAuthorityStore.getAdviserAuthorityModel(),
        errorList: AdviserAuthorityStore.getErrorList()
    };
}
var AdviserAuthoritySection = React.createClass({
    getInitialState: function() {
        return getStateFromStores();
    },
    componentDidMount: function() {
        AdviserAuthorityStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function() {
        AdviserAuthorityStore.removeChangeListener(this._onChange);
    },

    _onChange: function() {
        this.setState(getStateFromStores());
    },

    updateAndSendAdviserAuthorityModel: function(e) {        
        AdviserAuthorityActions.updateAdviserAuthorityModel(e.target.model, e.target.value ? YesNoValues.NO : YesNoValues.YES);        
        ApplicationActions.sendIsAdviserAuthorised(!e.target.value);
    },

    render: function() {
        var sectionNeedHelpInfo;
        var onlineAuthorityContent = (this.props.content) ? this.props.content.adviserAuthority : {};
        if (this.props.content) {
            sectionNeedHelpInfo = Formatter.formatString(onlineAuthorityContent.sectionHelp, { Link: this.props.content.yourDetails[this.props.productId].pdsLink });
        }
        
        return (
            <div className="adviserAuthoritySection" id="adviserAuthoritySection">
                <SectionHeader focus={this.props.focus} sectionName={onlineAuthorityContent.sectionHeader} sectionHelpText={this.props.content.common.sectionHeaderHelp} NeedHelpInfo={sectionNeedHelpInfo} />
                <section className="container">
                    <RadioButton 
                        id="adviserAuthoritySection"
                        name="isAdviserAuthorised"
                        prefix={onlineAuthorityContent.sectionPreText}
                        value={this.state.model.isAdviserAuthorised=== YesNoValues.YES ? false : true}
                        label={onlineAuthorityContent.sectionText}
                        contextualMessage={(this.state.model.isAdviserAuthorised === YesNoValues.NO) ? onlineAuthorityContent.aboutAdviserAuthority : null}
                        model="isAdviserAuthorised"
                        onChange={this.updateAndSendAdviserAuthorityModel} />
                        
                </section>
            </div>
        );
    }
});

module.exports = AdviserAuthoritySection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AdviserAuthority/AdviserAuthoritySection.jsx